import printJS from "print-js";

class printUtil{
    printTable(data,jsonFields,title){
        if(data.length == 0){return}
        const props = Object.values(jsonFields)
        const heads = Object.keys(jsonFields)
        let html = `<h1 class="my-title">${title}</h1>
        <table border="1"><thead><tr>`;
        heads.forEach(h=>{html += `<th>${h}</th>`})
        html += `</tr></thead><tbody>`
        for (let i = 0; i < data.length; i++) {
            let obj = data[i]
            let tr = `<tr>`
            for (let j = 0; j < props.length; j++) {
                // @ts-ignore
                tr += `<td>${obj[props[j]]}</td>`
            }
            tr += `</tr>`
            html += tr
        }
        html += `</tr></tbody></table>`
        const div = document.createElement('div')
        const printDOMID = 'printDOMElement'
        div.id = printDOMID
        div.innerHTML = html
        document.querySelector('body').appendChild(div)

        const printStyle = `
        .my-title {text-align: center }
        table { border-collapse: collapse }
        td {width: auto}
        `
        printJS({
            printable: printDOMID,
            type: 'html',
            scanStyles: false,
            style: printStyle
        })
        div.remove()
    }
}

export default printUtil
